interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "确认",
  cancelLabel = "取消",
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-foreground-950/40"
        onClick={() => {
          if (!loading) onCancel();
        }}
      ></div>

      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start gap-3">
          <span
            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${
              danger ? "bg-accent-100 text-accent-600" : "bg-primary-100 text-primary-600"
            }`}
          >
            <i className={`${danger ? "ri-error-warning-line" : "ri-question-line"} text-xl`}></i>
          </span>
          <div className="min-w-0">
            <h3 className="font-heading text-base font-semibold text-foreground-950">{title}</h3>
            <p className="mt-1.5 whitespace-pre-wrap text-sm leading-relaxed text-foreground-600">
              {message}
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-2 text-sm font-medium text-background-50 transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              danger ? "bg-accent-500 hover:bg-accent-600" : "bg-primary-500 hover:bg-primary-600"
            }`}
          >
            {loading ? (
              <i className="ri-loader-4-line animate-spin"></i>
            ) : (
              <i className={danger ? "ri-delete-bin-line" : "ri-check-line"}></i>
            )}
            {loading ? "处理中…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}